<div *ngIf="this.loaded">
    <router-outlet></router-outlet>
</div>